import React, { useState, useEffect, useRef } from 'react';
import { authApi } from '../services/api';

function Login({ onLogin, sessionExpired }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const sessionNoticeRef = useRef(null);

  // Issue #388: Move keyboard focus to the session-expired notice on first
  // render so screen-reader / keyboard users learn why they were logged out.
  useEffect(() => {
    if (sessionExpired && !error && sessionNoticeRef.current) {
      sessionNoticeRef.current.focus();
    }
  }, [sessionExpired, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await authApi.login(username, password);
      if (response.data.success && response.data.admin) {
        onLogin(response.data.admin);
      } else {
        setError('Anmeldung fehlgeschlagen');
      }
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-logo">
          <img src="/universe_logo_1.svg" alt="Universe Logo" className="logo-image" />
        </div>
        <h1 className="login-title">UNIVERSE</h1>
        <p className="login-subtitle">Admin Portal</p>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message" role="alert">{error}</div>}
          {sessionExpired && !error && (
            <div
              ref={sessionNoticeRef}
              className="info-message"
              role="status"
              aria-live="polite"
              tabIndex={-1}
            >
              Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.
            </div>
          )}

          <div className="input-group">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
              disabled={isLoading}
              className="login-input"
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
              disabled={isLoading}
              className="login-input"
            />
          </div>

          <button
            type="submit"
            className="login-button primary"
            disabled={isLoading}
          >
            {isLoading ? 'Anmelden...' : 'Anmelden'}
          </button>

          <button
            type="button"
            className="login-button secondary"
            disabled={isLoading}
          >
            Passwort vergessen
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
